import React from 'react';
import { FieldRenderProps, useField } from 'react-final-form';

import './InputPhoneNumber.css';
import AppStorage from 'Storage/Storage';
import Labels from '../../enums/Labels';
import { TafPhoneNumberInput } from '@taf-ui/react';
import { translate } from '../../utils/utils';
import { TafChangeEvent } from '@taf-ui/core';

export const defaultProps = {
  label: '',
  isRequired: true,
};
export type DefaultProps = Readonly<typeof defaultProps>;

export type Props = {
  isRequired?: boolean;
} & Partial<DefaultProps>;

const InputPhoneNumber = ({ isRequired = true }: Props) => {
  const storage = AppStorage.getInstance();
  const phoneNumberBody: FieldRenderProps<string> = useField('phoneNumberBody');
  const phonePrefix: FieldRenderProps<string> = useField('phonePrefix');

  const getValue = (): string => {
    return phonePrefix.input.value + phoneNumberBody.input.value;
  };

  const handleChange = (e: CustomEvent<TafChangeEvent<string>>) => {
    const phoneValue = e.detail.value;
    const prefix = phoneValue.slice(0, 3);
    const phone = phoneValue.slice(3, phoneValue.length);
    phoneNumberBody.input.onChange(phone);
    phonePrefix.input.onChange(prefix);
  };

  return (
    <div
      className="phone-number-wrapper"
      aria-label={translate(Labels.PERSONAL_DETAILS_PHONE, storage.getLocale)}
    >
      {/* Temporary fix for https://tafit.atlassian.net/browse/FE-15: Add the `rs_skip` class to TafPhoneNumberInput and move the aria-label to its parent. To fully resolve, remove the aria-label from the country code select field. */}
      <TafPhoneNumberInput
        inputId="phoneNumber"
        name="phoneNumber"
        label={translate(Labels.PERSONAL_DETAILS_PHONE, storage.getLocale)}
        value={getValue()}
        onTafChange={handleChange}
        onTafBlur={() => phoneNumberBody.input.onBlur()}
        validationState={
          phoneNumberBody.meta.error && phoneNumberBody.meta.touched
            ? 'error'
            : undefined
        }
        validationMessage={translate(
          phoneNumberBody.meta.error as Labels,
          storage.getLocale,
        )}
        required={isRequired}
        className="rs_skip"
      />
    </div>
  );
};
export default InputPhoneNumber;
